import React, { useRef } from 'react';
import './hero.scss';
import logo from '../../assets/logo.png';
import VideoLoop from '../VideoLoop/VideoLoop';
import videoD from '../../assets/heroD.mp4';
import videoM from '../../assets/heroM.mp4';

function Hero() {
  const heroRef = useRef();
  const videoData = { videoD: videoD, videoM: videoM };

  return (
    <section className="hero" ref={heroRef}>
      <VideoLoop data={videoData} />
      <div className="hero__nav">
        <a
          href="https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/"
          target="_blank"
          rel="sponsored"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
          >
            <path
              className="arrow__path"
              d="M0.363604 6.3636C0.0121321 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987512 7.36396 0.63604C7.01249 0.284568 6.44264 0.284568 6.09117 0.63604L0.363604 6.3636ZM2 6.1L1 6.1L1 7.9L2 7.9L2 6.1Z"
              fill="white"
            />
          </svg>
          Back to hub
        </a>
        <img alt="It starts with Intel" src={logo} className="hero__logo hero__logo-d" />
      </div>
      <img alt="It starts with Intel" src={logo} className="hero__logo hero__logo-m" />
      <h1>
        The Revolution Happening
        <br />
        Under The Hood
      </h1>
    </section>
  );
}

export default Hero;
